<template>
    <section class="sear-wrap">
        <h3 class="title">搜索推广</h3>
        <div class="flex">
            <div class="sear-div-line">
                <span class="sear-title">本地竞争同行 </span>
                <span class="sear-total">{{ querySearchEffect.numOfPeer ? querySearchEffect.numOfPeer : '0' }}家
                    <el-tooltip class="item" effect="dark" content="系统找出投放该关键词且近一年有消费的中小账户作为竞争同行。"
                        placement="top-start">
                        <i class="el-icon-warning"></i>
                    </el-tooltip>
                </span>
            </div>
            <div class="industry-select-wrap">
                <div class="com-div-wrap">
                    <span class="industry-select-title">
                        本地同行太少？试试用行业筛选：
                    </span>
                    <el-select v-model="tradeValue" placeholder="请选择" @change='selectSubTrade' size="small">
                        <el-option v-for="item in tradeList" :key="item.tradeId" :label="item.tradeName"
                            :value="{ value: item.tradeName, label: item.tradeId, subTrade: item.subTrade }">
                        </el-option>
                    </el-select>
                    <el-select v-model="subTradeValue" placeholder="请选择" size="small" @change="clickSubTrade">
                        <el-option v-for="item in subTradeList" :key="item.tradeId" :label="item.tradeName"
                            :value="{ value: item.tradeName, label: item.tradeId }">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="boxContainer">
            <el-row :gutter="10">
                <el-col :span="6">
                    <div class="grid-content">
                        <span>{{ querySearchEffect.showTimes ? querySearchEffect.showTimes : '暂无数据' }}</span>
                        <span>户均月展现量</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content">
                        <span>{{ querySearchEffect.clickTimes ? querySearchEffect.clickTimes : '暂无数据' }}</span>
                        <span>户均月点击量</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content">
                        <span>{{ querySearchEffect.avgCsm ? querySearchEffect.avgCsm : '暂无数据' }}</span>
                        <span>户均月消费</span>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content">
                        <span>{{ querySearchEffect.avgClickPrice ? querySearchEffect.avgClickPrice : '暂无数据' }}</span>
                        <span>行业平均点击价格</span>
                    </div>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <div class="grid-content">
                        <span>{{ querySearchEffect.mainTime ? querySearchEffect.mainTime : '暂无数据' }}</span>
                        <span>黄金消费时段</span>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="grid-content">
                        <span>{{ querySearchEffect.mainRegion ? querySearchEffect.mainRegion : '暂无数据' }}</span>
                        <span>主要推广区域</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 同行案例 -->
        <div id="compeSearchCase">
            <h4 class="title">同行案例
                <el-tooltip class="item" effect="dark" content="仅展示所在运营单位开发的本地同行案例数据。" placement="top-start">
                    <i class="el-icon-warning"></i>
                </el-tooltip>
            </h4>
            <div class="search">
                <div class="tabs">
                    <div v-for="tab in tabsArray" :class="`tab ${activeName === tab.name ? 'active' : ''}`"
                        :key="tab.index" @click="clickTabCase(tab)">
                        {{ tab.name }}
                    </div>
                </div>
                <div class="searchContent">
                    <el-input placeholder="公司名、地址" v-model="inputWord" class="input-with-select" size="small">
                        <el-button slot="append" icon="el-icon-search" @click="comNameAddersearch"></el-button>
                    </el-input>
                </div>
            </div>
            <div v-for="(item) in CompanyList" :key="item.index">
                <el-table :data="item.list" style="width: 100%" :cell-style="columnStyle"
                    :default-sort="{ prop: 'renewTimes', order: 'descending' }">
                    <el-table-column prop="companyName" label="公司名称" width="220" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="adderss" label="公司地址" width="220" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="contactName" label="负责人">
                    </el-table-column>
                    <el-table-column prop="efftime" label="合作时间">
                    </el-table-column>
                    <el-table-column prop="renewTimes" label="续费次数">
                    </el-table-column>
                    <el-table-column prop="ideaLinkUrl" label="网址" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-link type="primary" :href="scope.row.ideaLinkUrl" target="_blank">{{
                                scope.row.ideaLinkUrl
                            }}</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页 -->
            <div v-if="this.CompanyList[0].list.length > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-size="PageSize" :current-page="page" layout="total, prev, pager, next" :total="totalCount">
                </el-pagination>
            </div>
        </div>
        <!-- 热门商业词推荐 -->
        <div id="compeSearchCase">
            <div class="flex">
                <h4 class="title">热门商业词推荐</h4>

                <!-- <span class="download"> <i class="el-icon-download"></i> 一键下载 </span> -->
            </div>

            <el-table :data="HotKeyWordList.slice((pageNumHE - 1) * pageSizeHE, pageNumHE * pageSizeHE)" style="width: 100%"
                :default-sort="{ prop: 'showMonth', order: 'descending' }">
                <el-table-column prop="wordText" label="热门商业词推荐" sortable>
                    <template slot-scope="scope">
                        <el-link type="primary" @click="search">{{ scope.row.wordText }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="showMonth" label="户均月展现量" sortable>
                </el-table-column>
                <el-table-column prop="clickMonth" label="户均月点击量" sortable>
                </el-table-column>
                <el-table-column prop="csmMonth" label="户均月消费量" sortable>
                </el-table-column>
                <el-table-column prop="avgPrice" label="关键词平均点击价格" sortable>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div v-if="this.HotKeyWordList.length > 0">
                <el-pagination @size-change="handleSizeChangeHE" @current-change="handleCurrentChangeHE"
                    :page-size="pageSizeHE" :current-page="pageNumHE" layout="total, prev, pager, next"
                    :total="this.HotKeyWordList.length">
                </el-pagination>
            </div>
        </div>
        <!-- 消费趋势 (24h) -->
        <div id="compeSearchCase">
            <div class="flex">
                <h4 class="title">消费趋势 (24h)</h4>
            </div>
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="tabs">
                        <div v-for="(item, index) in tabsArray2" :key="item" :class="{ active: index == num }"
                            class="tab" @click="clickTabCsmTrend(index)">
                            {{ item }}
                        </div>
                    </div>
                    <div class="grid-content" id="CsmTrend" style="height: 250px;"></div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <h3 class="rank-h-title">黄金推广时段TOP5</h3>
                        <div class="rank-div-header">
                            <el-table size="medium" :data="CsmTrendDataTop.top5" style="width: 100%"
                                :default-sort="{ prop: 'id', order: 'ascending' }">
                                <el-table-column prop="id" label="排名" width="80">
                                </el-table-column>
                                <el-table-column prop="name" label="时段">
                                </el-table-column>
                                <el-table-column prop="percent" label="占比">
                                    <template slot-scope="scope">
                                        {{ scope.row.percent | numFilter }} %
                                        <!-- <span class="calcLine" style="width: 50.9792px;"></span> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 热门投放地域 -->
        <div id="compeSearchCase">
            <div class="flex">
                <h4 class="title">热门投放地域</h4>
            </div>
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="grid-content" id="OnRegion" style="height: 600px;"></div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <h3 class="rank-h-title">热门投放地域TOP5</h3>
                        <div class="rank-div-header">
                            <el-table :show-header="false" size="medium" :data="resOnRegionData.slice(0, 5)"
                                style="width: 100%" :default-sort="{ prop: 'index', order: 'ascending' }">
                                <el-table-column prop="index" label="排名" width="80">
                                </el-table-column>
                                <el-table-column prop="name" label="省市">
                                </el-table-column>
                                <el-table-column prop="value" label="占比">
                                    <template slot-scope="scope">
                                        {{ scope.row.value }}
                                        <!-- <span class="calcLine" style="width: 10.9792px;"></span> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </section>
</template>
<script>
import * as echarts from 'echarts';
import china from '../assets/china.json'
import { getTrade, getQueryEffect, getSearchPeerInfo, getHotKeyword, getCsmTrend,getPeerCompete } from '../utils/request.js'
import { Loading } from 'element-ui'
export default {
    props: ["keyWord", "regionValue"],
    data() {
        return {
            firstTradeId:'',
            inputWord: '',//公司名，地址
            CompanyList: [{ //同行案例
                bizFeeDto: null,
                input: '',
                isIndustryDetailClick: false,
                total: 0,
                queryWordId: '',
                word: '',
                list: []
            }],
            tradeList: [],
            tradeValue: '',
            subTradeValue: '',
            subTradeList: [],
            querySearchEffect: [//搜索推广主要信息查询
                {
                    avgClickPrice: '',
                    avgCsm: '',
                    avgMonthConsume: '',
                    avgYearRenewTimes: '',
                    clickTimes: '',
                    mainRegion: '',
                    mainTime: '',
                    numOfPeer: '',
                    renewTimes: '',
                    showTimes: ''
                }
            ],
            // tabsArray: ['全部', '三个月', '两年以内', '两年以上'],
            tabsArray: [{ monthGapId: 1, name: '全部', }, { monthGapId: 2, name: '三个月', }, { monthGapId: 3, name: '两年以内', }, { monthGapId: 4, name: '两年以上', }],
            monthGapId: 1,
            activeName: '全部',
            HotKeyWordList: [],//热门商业词
            activeName2: '全部',
            PageSize: 5, //默认每页显示的条数
            pageSizeHE: 5,
            page: 1, //当前页码
            pageNumHE: 1,
            totalCount: 1, //总条数
            // pageNumHE:1,
            tabsArray2: ['全部', 'PC端', '移动端'],
            num: "",
            CsmTrend: "",//消费趋势图表
            CsmTrendChart: "",
            CsmTrendOption: "",
            CsmTrendDataTop: { top5: [] },
            CsmTrendData://消费趋势数据
            {
                PC://计算机
                {
                    top5: [
                    ],
                    xaxis: {
                    },
                    yaxis: {
                    },
                },
                TOTAL://全部
                {
                    top5: [
                    ],
                    xaxis: {
                    },
                    yaxis: {
                    },
                },
                WX://移动端
                {
                    top5: [
                    ],
                    xaxis: {
                    },
                    yaxis: {
                    },
                },
            },
            OnRegion: "",//投放区域
            OnRegionChart: "",
            OnRegionOption: "",
            OnRegionData: [],
            resOnRegionData: []
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.initCsmTrendChart();//渲染消费趋势
            // this.initOnRegionChart();//渲染投放区域
            this.selectTrade();//渲染行业数据
            //this.initresdata();
        });
    },
    filters: {//小数转化百分比过滤器
        numFilter(value) {
            let realVal = Number(value * 100).toFixed(2)
            return Number(realVal)
        }
    },
    methods: {
        search() {//关键词，区域搜索
            console.log(this.regionValue,'搜索的区域ID');
            this.page = 1
            this.tradeValue = '';
            this.subTradeValue = ''; //清空行业筛选
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(',').replace(/all,/g,'').replace(/,all/g,''),
                month_gap_id: this.monthGapId,
            }
            getQueryEffect(params).then(res => { //渲染搜索推广主要信息
                let loadingInstance = Loading.service({  //启动loading服务
                    fullscreen: true,
                });
                if (res.status == 200) {
                    this.querySearchEffect = res.data.data
                    loadingInstance.close()
                } else {
                    this.$message.error(res.msg);
                }
            })
            // this.HangYeAnli()
            getSearchPeerInfo(params).then(res => { //同行案例查询
                if (res.status == 200) {
                    this.CompanyList[0].list = res.data.data.list
                    this.totalCount = res.data.data.total
                } else {
                    this.$message.error(res.msg);
                }
            })

            getHotKeyword(params).then(res => { //热门商业词推荐查询
                if (res.status == 200) {
                    this.HotKeyWordList = res.data.data
                } else {
                    this.$message.error(res.msg);
                }
            })

            getCsmTrend(params).then(res => {//消费趋势查询
                if (res.status == 200) {
                    this.CsmTrendData = res.data.data 
                    if (this.CsmTrendData.TOTAL.top5.length > 0 ) {
                        this.$nextTick(() => {
                            this.CsmTrendDataTop.top5 = res.data.data.TOTAL.top5
                            this.initCsmTrendChart()
                        })
                    } 
                    // this.CsmTrendDataTop.top5 = res.data.data.TOTAL.top5
                    // this.initCsmTrendChart()
                    console.log(this.CsmTrendData,'消费趋势查询');
                } else {
                    this.$message.error(res.msg);
                }
            })

            getPeerCompete(params).then( res => {//投放趋势查询
                if (res.status == 200) {
                    this.OnRegionData = res.data.data
                    console.log(this.OnRegionData,'投放地域')
                    this.$nextTick(() => {
                        this.initOnRegionChart()
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        comNameAddersearch() { //公司名，地址筛选
            console.log(this.inputWord, 'comNameAddersearch')
            this.page = 1
            this.HangYeAnli()
        },
        clickTabCase(tab) {//时间范围筛选
            this.activeName = tab.name;
            this.page = 1
            // this.firstTradeId = ''
            // this.updateTab();
            this.monthGapId = tab.monthGapId
            console.log(tab, 'clickTabCase')
            // this.HangYeAnli()
            if (this.subTradeList.length > 0 || this.CompanyList[0].list.length > 0 || this.keyWord.length > 0) {
                this.HangYeAnli()
            }
        },
        selectTrade() { //获取行业数据
            let params = {
            }
            getTrade(params).then(res => {
                if (res.status == 200) {
                    this.tradeList = res.data.data
                } else {
                    this.$message.error(res.msg);
                }
                console.log(params, 'params')
                console.log(res, 'Trade')
            })
        },
        selectSubTrade(e) {//二级行业筛选
            this.subTradeValue = ''
            let params = {
                trade_first_id: e.label,
            }
            getTrade(params).then(res => {
                if (res.status == 200) {
                    console.log(res, '--------------subTradeList')
                    this.subTradeList = res.data.data
                } else {
                    this.$message.error(res.msg);
                }
                console.log(params, 'params')
                console.log(res, 'Trade')
            })
        },
        clickSubTrade(e) { //点击行业
            this.page = 1
            this.firstTradeId = e.label
            this.TuiGuangXinXi()
            this.HangYeAnli()
            this.ReCi()
            this.XiaoFeiQuShi()
            this.TouFangDiYu()
        },
        // 搜索推广主要信息查询
        TuiGuangXinXi() {
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(','),
                trade_id: this.firstTradeId,
                month_gap_id: this.monthGapId
            }
            let loadingInstance = Loading.service({  //启动loading服务
                fullscreen: true,
            });
            getQueryEffect(params).then(res => {

                if (res.status == 200) {
                    this.querySearchEffect = res.data.data
                    console.log(this.querySearchEffect, 'getQueryEffect')
                    loadingInstance.close()
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 同行案例查询
        HangYeAnli(n1) {
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(','),
                trade_id: this.firstTradeId,
                page_size: 5,
                page_num: n1,
                month_gap_id: this.monthGapId,
                input_word: this.inputWord
            }
            let loadingInstance = Loading.service({  //启动loading服务
                fullscreen: true,
            });
            getSearchPeerInfo(params).then(res => {
                if (res.status == 200) {
                    this.CompanyList[0].list = res.data.data.list
                    this.totalCount = res.data.data.total
                    console.log(this.totalCount, '------------------totalCount')
                    console.log(this.CompanyList, 'getSearchPeerInfo')
                    this.$nextTick(() => {
                        loadingInstance.close()
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        //热门商业词推荐查询
        ReCi() {
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(','),
                trade_id: this.firstTradeId,
            }
            let loadingInstance = Loading.service({  //启动loading服务
                fullscreen: true,
            });
            getHotKeyword(params).then(res => {
                if (res.status == 200) {
                    this.HotKeyWordList = res.data.data
                    this.$nextTick(() => {
                        loadingInstance.close()
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 消费趋势(24)小时查询
        XiaoFeiQuShi() {
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(','),
                trade_id: this.firstTradeId,
            }
            let loadingInstance = Loading.service({  //启动loading服务
                fullscreen: true,
            });
            getCsmTrend(params).then(res => {
                if (res.status == 200) {
                    this.CsmTrendData = res.data.data
                    // if (this.CsmTrendData.TOTAL.top5.length > 0) {
                    //     this.$nextTick(() => {
                    //         this.CsmTrendDataTop.top5 = res.data.data.TOTAL.top5
                    //         this.initCsmTrendChart()
                    //     })
                    // }
                            this.CsmTrendDataTop.top5 = res.data.data.TOTAL.top5
                            this.initCsmTrendChart()
                    loadingInstance.close()
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        //投放地域
        TouFangDiYu() {
            let params = {
                word: this.keyWord,
                region_ids_str: this.regionValue.join(','),
                trade_id: this.firstTradeId,
            }
            let loadingInstance = Loading.service({  //启动loading服务
                fullscreen: true,
            });
            getPeerCompete(params).then( res => {
                if (res.status == 200) {
                    this.OnRegionData = res.data.data
                    console.log(this.OnRegionData,'投放地域')
                    this.$nextTick(() => {
                        this.initOnRegionChart()
                    })
                    loadingInstance.close()
                } else {
                    this.$message.error(res.msg);
                }
            })
        },
        // 改变Table某一列的背景颜色
        // columnIndex为列下标
        columnStyle({ row, column, rowIndex, columnIndex }) {
            console.log(row)
            console.log(column)
            console.log(rowIndex)
            if (columnIndex == 3 || columnIndex == 4) {
                //让下标为1的列数背景颜色显示为红色（颜色自定义根据大家需求来）
                return 'color:#ff8e00'
            }
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`)
            // this.page=val
            // this.HangYeAnli(val,1)
            this.currentPage = 1
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`)
            this.page = val
            // 切换页码时，要获取每页显示的条数
            this.HangYeAnli(this.page)
        },
        handleSizeChangeHE(val) {
            this.pageNumHE = 1;
            this.pageSizeHE = val;
        },
        handleCurrentChangeHE(val) {
            this.pageNumHE = val;
        },
        initCsmTrendChart() {//消费趋势
            this.CsmTrend = document.getElementById("CsmTrend");
            this.CsmTrendChart = echarts.init(this.CsmTrend);
            console.log(this.CsmTrendData, '--------消费趋势数据')
            this.CsmTrendOption = {
                grid: {
                    left: 30,
                    top: 30,
                    right: 30,
                    bottom: 30,
                },
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    type: 'category',
                    // data: ['0:00', '2:00', '4:00', '6:00', '8:00', '10:00', '12:00','14:00', '16:00', '18:00', '20:00', '22:00']
                    data: this.CsmTrendData.TOTAL.xaxis.data
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '消费趋势',
                        // data: [0.25, 1.35, 5.62, 4.23, 15.20, 20.33, 20.35,30.62, 21.23, 15.20, 20.33, 20.35],
                        data: this.CsmTrendData.TOTAL.yaxis.data,
                        type: 'line',
                        smooth: true
                    }
                ]
            };
            // document.getElementById('CsmTrend').removeAttribute('_echarts_instance_');
            this.CsmTrendOption && this.CsmTrendChart.setOption(this.CsmTrendOption, true);
            window.addEventListener("resize", () => {//图表尺寸自适应
                this.CsmTrendChart.resize();
            });
        },

        clickTabCsmTrend(index) { // 全部、PC端、移动端
            this.CsmTrend = document.getElementById("CsmTrend");
            this.CsmTrendChart = echarts.init(this.CsmTrend);
            this.num = index;//通过添加类名控制选项卡样式
            console.log(this.num, '=======num');
            if (index == 0) {
                this.CsmTrendOption = {
                    yAxis: {
                        type: "value",
                    },
                    series: [
                        {
                            data: this.CsmTrendData.TOTAL.yaxis.data,
                            type: 'line',
                            smooth: true
                        },
                    ],
                };
                this.CsmTrendOption && this.CsmTrendChart.setOption(this.CsmTrendOption);//更改（而非覆盖）图表数据
                this.CsmTrendDataTop.top5 = this.CsmTrendData.TOTAL.top5;
            } else if (index == 1) {
                this.CsmTrendOption = {
                    yAxis: {
                        type: "value",
                    },
                    series: [
                        {
                            data: this.CsmTrendData.PC.yaxis.data,
                            type: 'line',
                            smooth: true
                        },
                    ],
                };
                this.CsmTrendOption && this.CsmTrendChart.setOption(this.CsmTrendOption);
                this.CsmTrendDataTop.top5 = this.CsmTrendData.PC.top5;
            } else if (index == 2) {
                this.CsmTrendOption = {
                    yAxis: {
                        type: "value",
                    },
                    series: [
                        {
                            data: this.CsmTrendData.WX.yaxis.data,
                            type: 'line',
                            smooth: true
                        },
                    ],
                };
                this.CsmTrendOption && this.CsmTrendChart.setOption(this.CsmTrendOption);
                this.CsmTrendDataTop.top5 = this.CsmTrendData.WX.top5;
            }
        },

        initOnRegionChart() { //投放区域
            this.OnRegion = document.getElementById("OnRegion");
            this.OnRegionChart = echarts.init(this.OnRegion);
            echarts.registerMap('china', china);
            this.resOnRegionData = this.OnRegionData.map((item, index) => {
                let nRegion = {}
                nRegion.index = index + 1
                nRegion.id = item.provId
                nRegion.name = item.provName
                nRegion.value = item.avgCsmMonthly
                return nRegion
            })
            console.log(this.resOnRegionData, '--------------resOnRegionData');
            this.OnRegionOption = {
                grid: {
                    left: 30,
                    top: 30,
                    right: 30,
                    bottom: 30,
                },
                tooltip: {
                    trigger: 'item',
                    formatter: function (a) {
                        var toolTiphtml = `${a.data['name']}</br>全国排名:${a.data['index']}</br>户均月消费:${a.data['value']}`
                        return toolTiphtml;
                    }
                    
                },
                visualMap: { //地图图例
                    show: false,
                    left: 26,
                    bottom: 40,
                    showLabel: true,
                    pieces: [        //根据数据大小，各省显示不同颜色
                        {
                            gte: 9000,
                            label: ">= 9000",
                            color: "#007ee5"
                        },
                        {
                            gte: 7000,
                            lt: 8999,
                            label: "7000 - 8999",
                            color: "#2983e6"
                        },
                        {
                            gte: 5000,
                            lt: 6999,
                            label: "5000 - 6999",
                            color: "#4d90e8"
                        },
                        {
                            gte: 4000,
                            lt: 5999,
                            label: "4000 - 5999",
                            color: "#639ceb"
                        },
                        {
                            gte: 2000,
                            lt: 3999,
                            label: "2000 - 3999",
                            color: "#72a6ee"
                        },
                        {
                            gte: 1000,
                            lt: 1999,
                            label: "1000 - 1999",
                            color: "#7dadf1"
                        },
                        {
                            gte: 800,
                            lt: 999,
                            label: "800 - 999",
                            color: "#6aa0ec"
                        },
                        {
                            gte: 500,
                            lt: 799,
                            label: "500 - 799",
                            color: "#91bbf2"
                        },
                        {
                            gte: 200,
                            lt: 499,
                            label: "200 - 499",
                            color: "#9cc4f4"
                        },
                        {
                            gte: 100,
                            lt: 199,
                            label: "100 - 199",
                            color: "#b1d4f9"
                        },
                        {
                            gte: 50,
                            lt: 99,
                            label: "50 - 99",
                            color: "#bedefc"
                        },
                        {
                            gte: 20,
                            lt: 49,
                            label: "20 - 49",
                            color: "#bbdcfb"
                        },
                        {
                            gte: 10,
                            lt: 19,
                            label: '<10',
                            color: "#c0e1fd"
                        },
                        {
                            lt: 10,
                            label: '<10',
                            color: "#d8ecfe"
                        }
                    ]
                },
                geo: { //中国地图设置
                    map: "china",
                    scaleLimit: {
                        min: 1,
                        max: 2
                    },
                    zoom: 1,
                    top: 0,

                    label: {
                        normal: {
                            show: false,
                            fontSize: "14",
                            color: "rgba(0,126,229,0.7)"
                        }
                    },
                    itemStyle: {
                        normal: {
                            borderColor: "rgba(255,255,255,1)",
                            color: "rgba(0,126,229,.2)"
                        },
                        emphasis: {
                            areaColor: "#007ee5",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0
                        }
                    }
                },
                series: [
                    {
                        name: "",
                        type: "map",
                        geoIndex: 0,
                        data: this.resOnRegionData
                    },

                ]
            };
            this.OnRegionOption && this.OnRegionChart.setOption(this.OnRegionOption);
            window.addEventListener("resize", () => {//图表尺寸自适应
                this.OnRegionChart.resize();
            });
        }
    },

}

</script>

<style scoped lang="less">
@import "../assets/reset.less";

.flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.title {
    position: relative;
    padding-left: 15px;

    &::before {
        position: absolute;
        content: '';
        height: 20px;
        width: 5px;
        background-color: @Color8;
        top: 50%;
        margin-top: -10px;
        left: 0px;
    }
}

.sear-div-line {
    display: flex;
    align-items: center;
    color: @Color10;
    font-size: 14px;

    .sear-total {
        color: @Color8;
        font-size: 24px;
        margin-left: 5px;

        i {
            font-size: 14px;
        }
    }
}

.industry-select-wrap {
    display: flex;
    align-items: center;
    color: @Color10;
    font-size: 14px;

    .com-div-wrap {
        .el-select {
            margin-left: 5px;
        }
    }
}

.boxContainer {
    margin-top: 20px;

    .el-col-6 {
        .grid-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1.6em;
            padding: 10px;
            color: #fff;
            font-size: 16px;
        }

        &:nth-child(1) .grid-content {
            background-color: @Color2;
        }

        &:nth-child(2) .grid-content {
            background-color: @Color3;
        }

        &:nth-child(3) .grid-content {
            background-color: @Color4;
        }

        &:nth-child(4) .grid-content {
            background-color: @Color5;
        }
    }

    .el-col-12 {
        margin-top: 10px;

        .grid-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            line-height: 1.6em;
            padding: 10px;
            color: @Color8;
            font-size: 16px;
            background-color: @Color11;
        }

    }
}

#compeSearchCase {
    margin-top: 40px;
    margin-bottom: 80px;
}

h4.title {
    &::before {
        background-color: @Color6;
    }

    i {
        color: @Color8;
        font-size: 14px;
    }
}

.search {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.el-pagination {
    text-align: right;
    margin: 10px 0px;
}

.download {
    font-size: 14px;
    color: @Color7;
}

.tabs {
    display: flex;
    align-items: center;

    .tab {
        border: 1px solid #eee;
        background-color: #f9f9f9;
        margin-right: 15px;
        width: 76px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #333;
        font-size: 14px;
        cursor: pointer;
    }

    .active {
        background-color: #fdb050;
        border: 1px solid #fdb050;
        color: #fff;
    }
}

.rank-h-title {
    display: block;
    font-size: 16px;
    color: @Color6;
    margin-bottom: 10px;
}

.calcLine {
    position: relative;
    top: -1px;
    margin-left: 2px;
    display: inline-block;
    height: 5px;
    background-color: #00d7db;
    vertical-align: middle;
}

</style>
